/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { startCase } from "lodash";

export const normalizeJobTitle = (title) => `${title || ""}`.toLowerCase().trim().replace(/\s+/g, " ");

export const uniqueJobs = (jobs) =>
  jobs?.filter((job) => normalizeJobTitle(job?.title) !== "investor")?.filter(
    (job, index, self) =>
      index === self.findIndex((candidate) => normalizeJobTitle(candidate?.title) === normalizeJobTitle(job?.title))
  ) || [];

export const uniqueMappedJobValues = (jobs, getValue, formatValue = (value) => value) => {
  const normalizedValues = new Map();

  (jobs || []).forEach((job) => {
    const value = getValue(job);
    const normalizedValue = normalizeJobTitle(value);

    if (!normalizedValue || normalizedValues.has(normalizedValue)) return;

    normalizedValues.set(normalizedValue, formatValue(normalizedValue));
  });

  return Array.from(normalizedValues.entries())
    .sort(([leftValue], [rightValue]) => leftValue.localeCompare(rightValue))
    .map(([, value]) => value);
};

export const uniqueJobPayBasisValues = (jobs) =>
  uniqueMappedJobValues(jobs, (job) => job?.pay_basis, (normalizedValue) => startCase(normalizedValue));

export const uniqueJobSourceValues = (sourceOfTruthValues) =>
  uniqueMappedJobValues(sourceOfTruthValues, (sourceOfTruth) => sourceOfTruth, (normalizedValue) => normalizedValue);

export const hasJobSourceValue = (sourceOfTruthValues, sourceOfTruth) =>
  uniqueJobSourceValues(sourceOfTruthValues)?.includes(sourceOfTruth);
